import { FogadooraComponent } from './fogadoora/fogadoora.component';
import { SulinformFokuszSavComponent } from './components/sulinform-fokusz-sav/sulinform-fokusz-sav.component';
import { LemorzsolodasComponent } from './lemorzsolodas/lemorzsolodas.component';
import { TanuloHelyzetComponent } from './admin/tanulo/tanulo-helyzet.component';
import { TanuloEllenorzoComponent } from './admin/tanulo/tanulo-ellenorzo.component';
import { TobbIntezmenyComponent } from './components/tobb-intezmeny/tobb-intezmeny.component';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { IonicStorageModule } from '@ionic/storage-angular';
import { NyilvantartoComponent } from './nyilvantarto/nyilvantarto.component';
import { FooldalComponent } from './fooldal/fooldal.component';
import { ValasztoComponent } from './valaszto/valaszto.component';
import { LoginComponent } from './login/login.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SzerkZarInterceptor } from './components/szerk-zar/szerk-zar.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicSelectableComponent } from 'ionic-selectable';
import { ProfilComponent } from './profil/profil.component';
import { SettingsComponent } from './settings/settings.component';
import { TtfComponent } from './ttf/ttf.component';
import { MunkatarsakComponent } from './munkatarsak/munkatarsak.component';
import { SearchableSelectComponent } from "./util/searchable-select/searchable-select.component";
import { ProfilkepComponent } from './components/profilkep/profilkep.component';
import { OraOnlineComponent } from './components/ora-online/ora-online.component';
import { TemaValasztoComponent } from './components/tema-valaszto/tema-valaszto.component';
import { EtkezesNapiHianyzokComponent } from './components/etkezes-napi-hianyzok/etkezes-napi-hianyzok.component';
import { EtlapHetiComponent } from './components/etkezes-etlap/etlap-heti.component';
import { EtlapAdminComponent } from './components/etkezes-etlap/etlap-admin.component';
import { ChangelogComponent } from "./changelog/changelog.component";
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { AuthInterceptor } from "./auth.interceptor";
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
//import { Select2Module } from 'ng-select2-component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';

import { OverlayModule } from '@angular/cdk/overlay';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { Formio, FormioModule, FormioAppConfig } from '@formio/angular';
// import premium from '@formio/premium';
// Formio.use(premium);
import { FormioGrid } from '@formio/angular/grid';
import { FormioAuthService, FormioAuthConfig } from '@formio/angular/auth';
import { FormioResources } from '@formio/angular/resource';
import { PrismService } from './Prism.service';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FaliujsagComponent } from "./faliujsag/faliujsag.component";
import { EtkezesComponent } from "./etkezes/etkezes.component";
import { EtkezesComponent as ea } from "./admin/etkezes/etkezes.component";
import { LevelComponent } from "./level/level.component";
import { LicenseComponent } from "./license/license.component";
import { MessageComponent } from "./message/message.component";
import { DndDirective } from './dnd.directive';
import { DateInputDefaultsDirective } from './date-input.directive';
import { ProgressComponent } from './util/progress/progress.component';
import { environment } from 'src/environments/environment';
import { OrarendComponent } from './orarend/orarend.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
//import { MenueditorComponent } from './admin/menueditor/menueditor.component';
import { TantargyComponent } from './components/tantargy/tantargy.component';
import { OsztalyComponent } from './components/osztaly/osztaly.component';
import { TanarComponent } from './components/tanar/tanar.component';
import { TanteremComponent } from './components/tanterem/tanterem.component';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { FoglalasComponent } from './foglalas/foglalas.component';
import { UrlapComponent } from './urlap/urlap.component';
import { DokumentumaimComponent } from './dokumentumaim/dokumentumaim.component';
import { NaptarComponent } from './naptar/naptar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
//import { HomeComponent } from './admin/home/home.component';
import { ErtekezletComponent } from './ertekezlet/ertekezlet.component';
import { LandingComponent } from './landing/landing.component';
import { AdminLayoutModule } from './admin/admin-layout/admin-layout.module';
import { AllomanyComponent } from './admin/allomany/allomany.component';
import { ImportallomanyComponent } from './admin/importallomany/importallomany.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ImporttanulokComponent } from './admin/importtanulok/importtanulok.component';
import { TanuloComponent } from './admin/tanulo/tanulo.component';
import { CertComponent } from './admin/cert/cert.component';
import { NavComponent } from './admin/nav/nav.component';
import { SzulokComponent } from './admin/szulok/szulok.component';
import { ImportascComponent } from './admin/importasc/importasc.component';
import { PenzugyLayoutComponent } from './penzugy/penzugy-layout/penzugy-layout.component';
import { SzamlaComponent } from './penzugy/szamla/szamla.component';
import { EgyenlegComponent } from './penzugy/egyenleg/egyenleg.component';
import { TandijComponent } from './penzugy/tandij/tandij.component';
import { NormativaComponent } from './penzugy/normativa/normativa.component';
import { SzamlanewComponent } from './penzugy/szamlanew/szamlanew.component';
import { BizonylatSzerkesztoComponent } from './penzugy/ujbizonylat/bizonylat-szerkeszto.component';
import { ImportszulokComponent } from './admin/importszulok/importszulok.component';
import { ErtekesitComponent } from './penzugy/ertekesit/ertekesit.component';
import { PosComponent } from './admin/pos/pos.component';
import { mFooldalComponent } from './mediator/fooldal/fooldal.component';
import { mProfileComponent } from './mediator/profile/profile.component';
import { mCommunityComponent } from './mediator/community/community.component';
import { MediatorLayoutComponent } from './mediator/mediator-layout/mediator-layout.component';
import { mPostComponent } from './mediator/post/post.component';
import { Orarendv2Component } from './orarendv2/orarendv2.component';
import { ImporttanmenetComponent } from './admin/importtanmenet/importtanmenet.component';
import { KonyvelesComponent } from './adougy/konyveles/konyveles.component';
import { AdougyLayoutComponent } from './adougy/penzugy-layout/penzugy-layout.component';
import { AdofolyoszamlaComponent } from './adougy/adofolyoszamla/adofolyoszamla.component';
import { DataTablePagerComponent } from './util/pager.component';
import { ErtekelesekComponent } from './ertekelesek/ertekelesek.component';
import { AuthService } from './auth.service';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { ApiPrefixInterceptor } from './api-prefix.interceptor';
import { LoadingInterceptor } from './loading.interceptor';
import { TktComponent } from './tkt/tkt.component';
import { bFooldalComponent } from './bfooldal/bfooldal.component';
import { bBankComponent } from './bbank/bbank.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { bKontirComponent } from './bkontir/bkontir.component';
import { TorzsadatComponent } from './admin/torzsadat/torzsadat.component';
import { AdminNyomtatvanyComponent } from './admin/nyomtatvany/nyomtatvany.component';
import { NyomtatvanyComponent } from './nyomtatvany/nyomtatvany.component';
import { KretaOrarendComponent } from './kreta-orarend/kreta-orarend.component';
import { OsztalyfonokComponent } from './osztalyfonok/osztalyfonok.component';
import { OfMinosithetosegComponent } from './osztalyfonok/of-minosithetoseg/of-minosithetoseg.component';
import { OfKesveMulasztasComponent } from './osztalyfonok/of-kesve-mulasztas/of-kesve-mulasztas.component';
import { OfIgazolasElozmenyComponent } from './osztalyfonok/of-igazolas-elozmeny/of-igazolas-elozmeny.component';
import { SzuloiJegyekComponent } from './szuloi-jegyek/szuloi-jegyek.component';
import { CsaladiBelepesComponent } from './csaladi-belepes/csaladi-belepes.component';
import { BerletComponent } from './berlet/berlet.component';
import { SzuloiOrarendComponent } from './szuloi-orarend/szuloi-orarend.component';
import { WebshopAdminComponent } from './webshop-admin/webshop-admin.component';
import { WebshopCatalogAdminComponent } from './webshop-catalog-admin/webshop-catalog-admin.component';
import { AdminDokumentumokComponent } from './admin/dokumentumok/dokumentumok.component';
import { TanevvaltoComponent } from './admin/tanevvalto/tanevvalto.component';
import { DoksigeneratorComponent } from './admin/doksigenerator/doksigenerator.component';
import { BerComponent } from './admin/ber/ber.component';
import { IgazolasComponent } from './admin/igazolas/igazolas.component';
import { AdatbankComponent } from './admin/adatbank/adatbank.component';
import { AdminKezdolapComponent } from './admin/kezdolap/kezdolap.component';
import { IktatgatoModule } from './iktatgato/iktatgato.module';
import { AdminKerettantervSorrendComponent } from './admin/kerettanterv-sorrend/kerettanterv-sorrend.component';
import { CsoportBesorolasComponent } from './admin/csoport-besorolas/csoport-besorolas.component';
import { CsaladComponent } from './admin/csalad/csalad.component';
import { MacAllowlistComponent } from './admin/mac-allowlist/mac-allowlist.component';
import { AllomanyOsszevonasComponent } from './admin/allomany-osszevonas/allomany-osszevonas.component';
import { AdminTantargyOsszevonasComponent } from './admin/tantargy-osszevonas/tantargy-osszevonas.component';
import { AdminErtekelesTipusComponent } from './admin/ertekeles-tipus/ertekeles-tipus.component';
import { AdminFelmentesComponent } from './admin/felmentes/felmentes.component';
import { AdminFegyelmiComponent } from './admin/fegyelmi/fegyelmi.component';
import { AdminKretaCsoportComponent } from './admin/kreta-csoport/kreta-csoport.component';
import { AdminNaptarTipusComponent } from './admin/naptar-tipus/naptar-tipus.component';
import { AdminCsengoComponent } from './admin/csengo/csengo.component';
import { AdminFeljegyzesTipusComponent } from './admin/feljegyzes-tipus/feljegyzes-tipus.component';
import { EntraParositasComponent } from './admin/entra-parositas/entra-parositas.component';
import { EszkozeimComponent } from './eszkozeim/eszkozeim.component';
import { UzenetekComponent } from './uzenetek/uzenetek.component';
import { KretaSajatComponent } from './kreta-sajat/kreta-sajat.component';
import { TanmenetComponent } from './tanmenet/tanmenet.component';
import { KesesekComponent } from './kesesek/kesesek.component';
import { HelyettesitesBejelentesComponent } from './helyettesites-bejelentes/helyettesites-bejelentes.component';
import { LaptopComponent } from './laptop/laptop.component';
import { OsztalyBesorolasComponent } from './admin/osztaly-besorolas/osztaly-besorolas.component';
import { ZaradekModalComponent } from './components/zaradek-modal/zaradek-modal.component';
import { EntityPickerModalComponent } from './components/entity-picker-modal/entity-picker-modal.component';
import { AdminZaroertekelesComponent } from './admin/zaroertekeles/zaroertekeles.component';
import { AdminMicrosoftGraphComponent } from './admin/microsoft-graph/microsoft-graph.component';
import { AdminPushBeallitasComponent } from './admin/push-beallitas/push-beallitas.component';
import { AdminNaplozarasComponent } from './admin/naplozaras/naplozaras.component';
import { AdminKirstatComponent } from './admin/kirstat/kirstat.component';
import { KotelezoNyomtatvanyokComponent } from './admin/dokumentumok/kotelezo-nyomtatvanyok.component';
import { ArchivAtadasComponent } from './admin/dokumentumok/archiv-atadas.component';
import { TorzslapHataridoComponent } from './admin/dokumentumok/torzslap-hatarido.component';
import { MinioBeallitasComponent } from './admin/minio-beallitas/minio-beallitas.component';
import { LicencComponent } from './admin/licenc/licenc.component';
import { KretaNaplozComponent } from './admin/kreta-naploz/kreta-naploz.component';
import { KretaUtemezoKartyaComponent } from './admin/kreta-naploz/kreta-utemezo-kartya/kreta-utemezo-kartya.component';
import { KretaEugyComponent } from './admin/kreta-eugy/kreta-eugy.component';
import { IkszSzinkronComponent } from './admin/iksz-szinkron/iksz-szinkron.component';
import { KretaFeljegyzesComponent } from './admin/kreta-feljegyzes/kreta-feljegyzes.component';
import { IkszComponent } from './iksz/iksz.component';
import { SzuloiIkszComponent } from './szuloi-iksz/szuloi-iksz.component';
import { IntezmenyBelepoComponent } from './intezmeny-belepo/intezmeny-belepo.component';
import { IdpRegisztracioComponent } from './admin/idp-regisztracio/idp-regisztracio.component';
import { AlapertelmezettIntezmenyComponent } from './admin/alapertelmezett-intezmeny/alapertelmezett-intezmeny.component';
import { AdminJogosultsagComponent } from './admin/jogosultsag/jogosultsag.component';
import { AdminKinevezesComponent } from './admin/kinevezes/kinevezes.component';
import { AdminImpersonalasComponent } from './admin/impersonalas/impersonalas.component';
import { AdminTudasbazisComponent } from './admin/tudasbazis/tudasbazis.component';
import { AdminSmtpBeallitasComponent } from './admin/smtp-beallitas/smtp-beallitas.component';
import { AdminKonradBeallitasComponent } from './admin/konrad-beallitas/konrad-beallitas.component';
import { KonradComponent } from './konrad/konrad.component';
import { AdminJogosultakComponent } from './admin/jogosultak/jogosultak.component';
import { AdminJogkorokComponent } from './admin/jogkorok/jogkorok.component';
import { AdminAtsorolasComponent } from './admin/atsorolas/atsorolas.component';
import { AdminBesorolasKetTablaComponent } from './admin/besorolas-ket-tabla/besorolas-ket-tabla.component';
import { AdminTanuloKilepesComponent } from './admin/tanulo-kilepes/tanulo-kilepes.component';
import { AdminImportCsoporttagsagComponent } from './admin/importcsoporttagsag/importcsoporttagsag.component';
import { AdminImportCsoportComponent } from './admin/importcsoport/importcsoport.component';
import { AdminImportOrarendComponent } from './admin/importorarend/importorarend.component';
import { AdminFrissitesComponent } from './admin/frissites/frissites.component';
import { FrissitesFolyamatbanComponent } from './frissites-folyamatban/frissites-folyamatban.component';
import { KarbantartasInterceptor } from './karbantartas.interceptor';
import { AdminKeycloakFiokokComponent } from './admin/keycloak-fiokok/keycloak-fiokok.component';
import { AdminMenuszerkesztoComponent } from './admin/menuszerkeszto/menuszerkeszto.component';
import { JogviszonyModalComponent } from './components/jogviszony-modal/jogviszony-modal.component';
import { BelepesFiokComponent } from './components/belepes-fiok/belepes-fiok.component';
import { FajlNezoModalComponent } from './fajl-nezo-modal.component';
import { CheckoutSettingsComponent } from './admin/checkout-settings/checkout-settings.component';
import { StornoTomegesComponent } from './admin/storno-tomeges/storno-tomeges.component';
import { CashbookBeallitasComponent } from './admin/cashbook-beallitas/cashbook-beallitas.component';
import { SzamlatombComponent } from './admin/szamlatomb/szamlatomb.component';
import { CaesarModule } from './caesar/caesar.module';
import { NaploModule } from './naplo/naplo.module';
import { BerModule } from './ber/ber.module';
import { EszkozModule } from './eszkoz/eszkoz.module';
import { SzamlazoModule } from './szamlazo/szamlazo.module';
import { InventarioModule } from './inventario/inventario.module';
import { GepjarmuModule } from './gepjarmu/gepjarmu.module';

export function initAuth(auth: AuthService) {
  return () => auth.init();
}
function initializeKeycloak(keycloak: KeycloakService, auth: AuthService) {
  return () => { return () => auth.init();
    /*const isNative = Capacitor.isNativePlatform();
    if (isNative) {
      return () => auth.init();
    }
    else
      return keycloak.init({
        config: {
          url: environment.keycloak,
          realm: 'master',
          clientId: 'nyilvantarto',
        },
        initOptions: {
          onLoad: isNative ? 'login-required' : 'check-sso',

          // Force adapter depending on runtime
          adapter: isNative ? 'cordova' : 'default',

          // Hybrid apps usually behave better with this off
          checkLoginIframe: false,

          // Cordova adapter expects to come back via localhost
          ...(isNative
            ? {
              redirectUri: 'http://localhost',
              responseMode: 'query',
            }
            : {
              silentCheckSsoRedirectUri:
                window.location.origin + '/assets/silent-check-sso.html',
            }),
        },
      });*/
  };
}
/*const config: AuthConfig = {
  domain,
  clientId,
  authorizationParams: {
    redirect_uri: window.location.origin, //callbackUri,
    //scope: 'openid profile email offline_access read:users',
    audience: 'https://cnidp.eu.auth0.com/api/v2/',
  },
  // For using Auth0-Angular with Ionic on Android and iOS,
  // it's important to use refresh tokens without the falback
  useRefreshTokens: true,
  useRefreshTokensFallback: false,
  cacheLocation: 'localstorage',
};*/

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DndDirective,
    DateInputDefaultsDirective,
    ProgressComponent,
    NyilvantartoComponent,
    FooldalComponent,
    ValasztoComponent,
    ProfilComponent,
    SettingsComponent,
    TtfComponent,
    MunkatarsakComponent,
    ChangelogComponent,
    FaliujsagComponent,
    EtkezesComponent,
    LevelComponent,
    LicenseComponent,
    MessageComponent,
    OrarendComponent,
    ForbiddenComponent,
    //MenueditorComponent,
    TantargyComponent,
    OsztalyComponent,
    TanarComponent,
    TanteremComponent,
    FoglalasComponent,
    UrlapComponent,
    DokumentumaimComponent,
    NaptarComponent,
    //HomeComponent,
    ErtekezletComponent,
    SzamlaComponent,
    LandingComponent,
    EgyenlegComponent,
    TandijComponent,
    NormativaComponent,
    PenzugyLayoutComponent,
    AllomanyComponent,
    TanuloComponent,
    SzamlanewComponent,
    BizonylatSzerkesztoComponent,
    ea,
    CertComponent,
    NavComponent,
    SzulokComponent,
    ImportascComponent,
    ImportallomanyComponent,
    ImporttanulokComponent,
    ImportszulokComponent,
    ErtekesitComponent,
    PosComponent,
    MediatorLayoutComponent,
    mFooldalComponent,
    mProfileComponent,
    mCommunityComponent,
    mPostComponent,
    Orarendv2Component,
    ImporttanmenetComponent,
    AdougyLayoutComponent,
    KonyvelesComponent,
    AdofolyoszamlaComponent,
    DataTablePagerComponent,
    ErtekelesekComponent,
    TktComponent,
    bFooldalComponent,
    bBankComponent,
    bKontirComponent,
    TorzsadatComponent,
    AdminNyomtatvanyComponent,
    NyomtatvanyComponent,
    KretaOrarendComponent,
    OsztalyfonokComponent,
    SzuloiJegyekComponent,
    CsaladiBelepesComponent,
    BerletComponent,
    SzuloiOrarendComponent,
    WebshopAdminComponent,
    WebshopCatalogAdminComponent,
    AdminDokumentumokComponent,
    TanevvaltoComponent,
    DoksigeneratorComponent,
    BerComponent,
    IgazolasComponent,
    AdatbankComponent,
    AdminKezdolapComponent,
    AdminKerettantervSorrendComponent,
    OsztalyBesorolasComponent,
    CsoportBesorolasComponent,
    CsaladComponent,
    MacAllowlistComponent,
    AllomanyOsszevonasComponent,
    AdminTantargyOsszevonasComponent,
    AdminErtekelesTipusComponent,
    AdminFelmentesComponent,
    AdminFegyelmiComponent,
    AdminKretaCsoportComponent,
    AdminNaptarTipusComponent,
    AdminCsengoComponent,
    AdminFeljegyzesTipusComponent,
    EntraParositasComponent,
    EszkozeimComponent,
    UzenetekComponent,
    KretaSajatComponent,
    TanmenetComponent,
    KesesekComponent,
    HelyettesitesBejelentesComponent,
    LaptopComponent,
    ZaradekModalComponent,
    EntityPickerModalComponent,
    AdminZaroertekelesComponent,
    AdminMicrosoftGraphComponent,
    AdminPushBeallitasComponent,
    AdminNaplozarasComponent,
    AdminKirstatComponent,
    KotelezoNyomtatvanyokComponent,
    ArchivAtadasComponent,
    TorzslapHataridoComponent,
    MinioBeallitasComponent,
    LicencComponent,
    KretaNaplozComponent,
    KretaUtemezoKartyaComponent,
    KretaEugyComponent,
    IkszSzinkronComponent,
    KretaFeljegyzesComponent,
    IkszComponent,
    SzuloiIkszComponent,
    IntezmenyBelepoComponent,
    IdpRegisztracioComponent,
    AlapertelmezettIntezmenyComponent,
    AdminJogosultsagComponent,
    AdminKinevezesComponent,
    AdminImpersonalasComponent,
    AdminTudasbazisComponent,
    AdminSmtpBeallitasComponent,
    AdminKonradBeallitasComponent,
    KonradComponent,
    AdminJogosultakComponent,
    AdminJogkorokComponent,
    AdminAtsorolasComponent,
    AdminBesorolasKetTablaComponent,
    AdminTanuloKilepesComponent,
    AdminImportCsoporttagsagComponent,
    AdminImportCsoportComponent,
    AdminImportOrarendComponent,
    AdminFrissitesComponent,
    FrissitesFolyamatbanComponent,
    AdminKeycloakFiokokComponent,
    AdminMenuszerkesztoComponent,
    JogviszonyModalComponent,
    BelepesFiokComponent,
    FajlNezoModalComponent,
    CheckoutSettingsComponent,
    StornoTomegesComponent,
    CashbookBeallitasComponent,
    SzamlatombComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    TobbIntezmenyComponent,
    SulinformFokuszSavComponent,
    LemorzsolodasComponent,
    TanuloHelyzetComponent,
    TanuloEllenorzoComponent,
    FogadooraComponent,
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    AdminLayoutModule,
    CaesarModule,
    IktatgatoModule,
    NaploModule,
    BerModule,
    EszkozModule,
    SzamlazoModule,
    InventarioModule,
    GepjarmuModule,
    //AuthModule.forRoot(config),
    IonicStorageModule.forRoot(),
    FormsModule,
    IonicSelectableComponent,
    SearchableSelectComponent,
    TemaValasztoComponent,
    ProfilkepComponent,
    OfMinosithetosegComponent,
    OfKesveMulasztasComponent,
    OfIgazolasElozmenyComponent,
    OraOnlineComponent,
    EtkezesNapiHianyzokComponent,
    EtlapHetiComponent,
    EtlapAdminComponent,
    KeycloakAngularModule,
    FontAwesomeModule,
    NgxDatatableModule,
    NgSelectModule,
    NgOptionHighlightModule,
    OverlayModule,
    DragDropModule,
    AgGridModule,
    FullCalendarModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot(),
    FormioModule,
    FormioGrid,

    NgxDropzoneModule,


    //Select2Module
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    /*PrismService,*/FormioResources,
    { provide: APP_INITIALIZER, useFactory: initAuth, deps: [AuthService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    /*  A karbantartás-elkapó az AuthInterceptor UTÁN fut a válasz-ágon: nem a kérést
     *  módosítja, hanem a 503-as választ figyeli, és átviszi a felhasználót a
     *  „frissítés folyamatban" oldalra. */
    { provide: HTTP_INTERCEPTORS, useClass: KarbantartasInterceptor, multi: true },
    //  A szerkesztési zárak (X-Szerk-Zar) a módosító kérésekre – az ApiPrefix ELŐTT, hogy a relatív /api-t lássa.
    { provide: HTTP_INTERCEPTORS, useClass: SzerkZarInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  /*{
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService]
  },*/provideOAuthClient(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(library: FaIconLibrary, public platform: Platform) {
    library.addIconPacks(fas, fab, far);
  }
}
